import { Box, Chip } from "@mui/material";

export default function StatusAnimated({
    status,
    size = 10
}: StatusAnimatedProps) {

    const basicStyle = {
        width: size,
        height: size,
        borderRadius: '50%'
    }

    if (status === "Encerrado" || status === 'Cancelado')
        return (
            <Box
                sx={{
                    ...basicStyle,
                    backgroundColor: '#ff0000',
                }}
            />
        )

    if (status === "Fechando")
        return (
            <Chip
                label="Em andamento"
                sx={{
                    backgroundColor: '#1976d2', // azul do MUI
                    color: 'white',
                    animation: 'pulse 1.5s infinite ease-in-out',
                    '@keyframes pulse': {
                        '0%': {
                            transform: 'scale(0.95)',
                            boxShadow: '0 0 0 0 rgba(25, 118, 210, 0.7)',
                        },
                        '70%': {
                            transform: 'scale(1)',
                            boxShadow: '0 0 0 6px rgba(25, 118, 210, 0)',
                        },
                        '100%': {
                            transform: 'scale(0.95)',
                            boxShadow: '0 0 0 0 rgba(25, 118, 210, 0)',
                        },
                    },
                }}
                size="small"
            />
        )

    if (status === "Pendente")
        return (
            <Chip
                label="Pendente"
                sx={{
                    backgroundColor: '#ffeb3b',
                    color: 'rgba(0, 0, 0, 0.87)', // texto escuro para contraste
                }}
                size="small"
            />
        )

    return (
        <Box
            sx={{
                ...basicStyle,
                backgroundColor: 'darkgray',
            }}
        />
    )
}

interface StatusAnimatedProps {
    status: "Ativo" | "Encerrado" | "Finalizado" | 'Inativo' | "Pendente" | "Fechado" | "Cancelado" | "Fechando"
    size?: number
}

